/*
 * @Author: your name
 * @Date: 2020-08-21 15:25:20
 * @LastEditTime: 2022-07-31 02:37:40
 * @LastEditors: Francis
 * @Description: In User Settings Edit
 * @FilePath: \ki-web-projact\src\components\lib\interface.js
 */

/*
接口请求函数模块
返回值: promise对象
 */
import { get, post } from "./http";

// 登录
export const login = params => post(`/login/loginPwd?phone=${params.phone}&pwd=${params.pwd}`)

// 登出
export const loginOut = params => post(`/loginout`)



// 字典
export const searchDictData = data => get('/pallets/searchDictData', data)
// 会计 运输单位   
export const optionSelect = data => get('/pallets/optionSelect', data)
// 会计 发布货源提交
export const releasefr = data => post('/pallets/release', data)


// 会计-中标列表
export const palletsList = data => get(`/pallets/lists`, data)

// 会计-单位列表
export const getBindUnitList = data => get(`/pallets/bidUnitList?type=3`, data)
// 会计-查询货物种类
export const gettypegood = data => get(`/pallets/goodsTypeList`, data)

// 会计-更新中标
export const updateBidUnit = data => post('/pallets/updateBidUnit', data)

// 会计-个人信息
export const palletPersonInfo = () => get('/pallets/statistics')

// 会计-货盘列表
export const releaseList = data => get(`/pallets/list`, data)

// 调度-个人信息
export const dispatchPersonInfo = () => get('/dispatch/statistics')

// 调度--计划表
export const dispatchPlanList = (data) => get('/plan/list', data)

// 调度-- 发布
export const dispatchReleasePlan = (data) => get('/plan/release', data)

// 调度-- 修改
export const dispatchUpdatePlan = (data) => post('/plan/update', data)

// 调度-- 新增
export const dispatchSavePlan = (data) => post('/plan/save', data)

// 调度获取港口
export const dispatchGetPort = (data) => get("/plan/port", data)
// 中转港
export const transferss = (data) => get("/plan/transitPostList", data)


// 调度--工单列表
export const dispatchOrderList = (data) => get('/dispatch/lists', data)

// 调度--指派人员
export const dispatchWorkerList = (data) => get('/dispatch/installList', data)


export const dispatchGetCustomer = (data) => get('/pallets/bidUnitList?type=1', data)

// 调度--指派
export const dispatchOrderAssgin = (data) => post('/dispatch/assign', data)

// 调度--废标
export const dispatchPlanUnBind = (data) => get(`/dispatch/unbid`, data)

// 调度-- 提醒
export const dispatchOrderNotice = (data) => get('/dispatch/remind', data)

// 调度 -- 退回详情
export const dispatchChargeBack = (data) => get('/dispatch/chargeback', data)

// 调度 -- 打卡详情
export const dispatchDkLogList = (data) => get('/dispatch/dkLog', data)

// 

// 安装-个人信息
export const workOrderPersonInfo = (data) => post('/workOrder/countInstallNum', data)

// 安装--全部列表
export const workOrderAllOrder = (data) => post('/workOrder/queryAll', data)

// 安装--已接单，已完成列表
export const queryTakeOrCompleteWorkOrder = (data) => post('/workOrder/queryTakeOrCompleteWorkOrder', data)

// 安装-- 接单
export const acceptOrder = (data) => post('/workOrder/acceptOrder', data)

// 安装-- 打卡
export const dkWorkOrder = (data) => post('/workOrder/dkWorkOrder', data)

// 安装-- 详情
export const orderDetail = (data) => get('/workOrder/queryWorkOrderDetail', data)

// 安装-- 退回  
export const returnWorkOrder = (data) => post('/workOrder/returnWorkOrder', data)

// 安装-- 提交
export const sumbitOrder = (data) => post('/workOrder/submitWorkOrderDetail', data)
// 更换安装人员
export const updateInstallList = (data) => post('/dispatch/updateInstallList', data)

// 安装-维修列表
export const repair = (data) => get('/repair/list', data)
// 安装-获取维修单详细信息
export const repairgetInfo = (data) => get('/repair/getInfo', data)
// 安装-登记
export const register = (data) => post('/repair/register', data)

// 安装-协助人
export const updateWordInfo = (data) => post('/workOrder/updateWordInfo', data)




// 安装 -- 所有列表
export const workOrderList = (data) => get('/workOrder/workOrderList', data)
// 安装 -- 工单详情提交安装人员列表
export const WorkUserList = (data) => get('/workOrder/queryWorkUser', data)

// 安装-处理工单 处理工单 type =1 接单;type=2 退回；type =3打卡
export const handleOrder = (data) => post('/workOrder/handleOrder', data)

// 安装- 配件列表
// 配件列表 type=1 配件接收列表 ,type=2 核销列表 注意：(配件接收和核销是两个表,返回的数据不一样)
// fittingState 控制状态 2(未接收) 3(已接收)
export const getWorkFitList = (data) => get('/fitting/list', data)

// 安装 - 配件 - 确认接收
export const receiveWorkFit = (data) => post('/fitting/confirmReceive', data)

// 安装 -配件- 字典
export const getDictList = (data) => get('/fitting/categoryList', data)

// 安装 - 配件 - 取消申请审核
export const cancelWorkFit = (data) => post(`/fitting/cancelApply?id=${data.id}`)

// 安装 - 配件 - 新建审核
export const addWorkFit = (data) => post('/fitting/addVerification', data)

// 安装 - 配件 -配件类型字典
export const stockad = (data) => post('/fitting/stock', data)
// 安装 - 配件 -分派保存
export const assignb = (data) => post('/fitting/assign', data)

// 安装我的库存
// export const stockfr = () => get('/fitting/stock')

//欣港业务列表
export const xgBusinessList = (data) => get('/biz/xg/downstream/list', data)

//欣港业务列表修改是否生成工单状态
export const xgBusinessListUpdate = (data) => post('/biz/edit', data)




// 审核-个人信息
export const verifyPersonInfo = (data) => post('/verifyPerson/countCheckPersonData', data)


// 审核-工单-审核通过和驳回
export const queryWorkOrderRejectOrPassList = (data) => post('/verifyPerson/queryWorkOrderRejectOrPassList', data)

// 审核-全部列表
export const verifyAllList = (data) => get('/verifyPerson/queryToVerifyList', data)

// 审核-工单-待审核
export const queryToVerifyList = (data) => get('/verifyPerson/queryToVerifyList', data)

// 审核
export const rejectOrPassWorkOrder = (data) => post('/verifyPerson/rejectOrPassWorkOrder', data)

// 审核-配件-列表
// 查询配件核销管理列表 vType =1 未核销；vType =2 已核销 state:1未审核，2 已驳回，3 已核销通过
export const verificationList = (data) => get('/verification/list', data)

// 审核-配件-详情
export const getVerificationInfo = (data) => get('/verification/getVerificationInfo', data)

// 审核-配件-审核
export const verifyVerfication = (data) => post('/verification/verify', data)

// 文件上传
export const uploadFile = (data) => post('/common/upload', data)




// 小船工单
export const generate = (data) => post('/workOrder/generate', data)

// 通用页面-船只详情
export const getShipInfo = (data) => get('/ship/list', data)
